import { getSvgFill } from "utils"

const GainWeight = ({ isSelected }: { isSelected: boolean }) => {
  const { backgroundFill, pathFill } = getSvgFill(isSelected)

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
    >
      <g clipPath="url(#clip0_9310_26442)">
        <path
          d="M19.7152 15.8071C19.6686 15.6939 19.7042 15.5375 19.7289 15.4081C20.3286 12.2186 19.1757 9.43628 17.642 6.75099C17.3052 6.16324 17.0231 5.60785 17.0067 4.89339C16.9656 3.29731 16.0783 2.18113 14.5995 1.64462C12.9481 1.04878 11.2611 0.485301 9.54401 0.129419C6.60001 -0.479895 4.90756 1.14045 5.20606 4.11153C5.38407 5.88015 7.15321 6.77795 8.68409 5.85589C9.69737 5.24658 10.979 5.68064 11.9923 4.9581C12.2525 4.77207 12.666 5.31667 12.8303 5.68334C13.0385 6.14437 12.9974 6.62427 12.9097 7.12574C12.6167 8.79731 11.8992 10.3691 11.7541 12.3373C10.2862 11.1537 8.79363 10.4446 7.0957 10.8571C6.17827 11.0782 5.61138 10.9865 4.86648 10.3853C3.7546 9.4902 2.29219 9.32305 0.991356 9.84069C-0.246491 10.3314 0.0273689 11.6309 0.0218917 12.6851C0.00819874 14.9686 0.0191531 17.2522 0.0218917 19.5358C0.0218917 21.5471 0.262888 21.6657 2.36066 21.4797C3.54921 21.3745 4.66382 20.8056 5.95918 21.2181C9.99314 22.5069 13.808 22.2885 17.527 19.889C19.2167 18.7998 20.6299 18.0422 19.7179 15.8071H19.7152Z"
          fill={pathFill}
          fillOpacity={isSelected ? 1 : 0.6}
        />
      </g>
      <defs>
        <clipPath id="clip0_9310_26442">
          <rect width="20" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default GainWeight
